module.exports = __webpack_public_path__ + "static/media/tab.c97922d6.svg";